module.exports = __webpack_public_path__ + "static/img/8.db07e1a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/6/zh/8.png
// module id = m5+8
// module chunks = 0